import type { MarketVariants } from '@/lib/i18n'

export type Slide9CloseCopy = {
  eyebrow: string
  title: string
  // US "defense" auto-spells to "defence" on the Qatar face via useSlideCopy.
  body: string
  cta: string
}

export const copy: MarketVariants<Slide9CloseCopy> = {
  US: {
    eyebrow: 'Chapter 5 complete',
    title: 'Small habits. Big protection.',
    body:
      "Good habits can block a lot of problems before they start. But even with a solid defense, things can still slip through. Up next, a look at how to respond if you think you've been scammed.",
    cta: 'Start Chapter 6',
  },
  ar: {
    eyebrow: 'اكتمل الفصل 5',
    title: 'عادات صغيرة. حماية كبيرة.',
    body:
      'العادات الجيدة تمنع كثيراً من المشكلات قبل أن تبدأ. لكن حتى مع دفاع متين، قد يتسلّل شيء ما. في الفصل التالي، نتعرّف على كيفية التصرّف إذا شككت في أنك تعرّضت للاحتيال.',
    cta: 'ابدأ الفصل 6',
  },
}
